/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {News} from '../../core/_models'
import {useListView} from '../../core/ListViewProvider'

type Props = {
  documents: News
}

const DocumentsInfoCell: FC<Props> = ({documents}) => {
  const {setItemIdForUpdate} = useListView()
  const openEditModal = () => {
    setItemIdForUpdate(documents.id)
  }

  return (
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='d-flex flex-column'>
        <a
          onClick={openEditModal}
          role='button'
          className='text-gray-800 text-hover-primary mb-1 pointer-cli'
        >
          {documents.title}
        </a>
      </div>
    </div>
  )
}

export {DocumentsInfoCell}
